import {HTTP} from '../services/HttpService'
// import router from '../router'

/**
 * AuthenticationService takes care of authenticating the user and maintaining the state the user
 * This uses the local storage for persisting the user to be able to survive page refresh.
 *
 * This also maintains a user member field to make it reactive.
 *
 * Provides isAuthenticated, getUser, authenticate and logout methods
 * This is a singleton object, created only once when the application is loaded
 */
class AuthenticationService {
  /**
   * Constructor - initializes the AuthorizationService.
   *
   * This will check the local storage if a user exists.
   * If the user exists, it loads it and sets the user member field
   * This also loads the stored credentials and sets the HTTP Authorization headers globally
   * so succeeding calls do not need to set it manually
   */
  constructor () {
    // console.log('AuthenticationService() - constructor')
    this.user = null
    // we check if the local storage contains a user
    var userJson = sessionStorage.getItem('user')
    if (userJson != null) {
      // console.log('AuthenticationService() - user found in sessionStorage =>' + userJson)
      this.user = JSON.parse(userJson)
      // console.log('AuthenticationService() - loading user credentials from storage')
      var credentials = JSON.parse(sessionStorage.getItem('credentials'))
      // console.log('AuthenticationService() - setting http authorization headers')
      HTTP.defaults.headers.Authorization = 'Basic ' + credentials
    }
  }
  /**
   * This returns true if a user has authenticated
   */
  isAuthenticated () {
    // console.log('AuthenticationService.isAuthenticated() => ' + (this.user != null))
    if (this.user == null) {
      return false
    }
    return true
  }
  /**
   * Get the current active user if available
   */
  getUser () {
    return this.user
  }
  /**
   * Update the current user data
   */
  setUser (user) {
    this.user = user
    sessionStorage.setItem('user', JSON.stringify(this.user))
  }
  /**
   * Authenticate a user given the username and password.
   * If authentication is successful, the following actions are performed
   * 1.) Update the user member field so VueJS will be notified
   * 2.) Store the user to the local storage so we can survive a page refresh
   * 3.) Store the credentials to the local storage so we can set the authentication headers when the page is reloaded
   * 4.) Set the http authorization headers
   *
   * If the authorization fails, it throws an exception
   */
  authenticate (username, password) {
    return new Promise((resolve, reject) => {
      // console.log('AuthenticationService.authenticate()')
      var credentials = btoa(username + ':' + password)
      // console.log('AuthenticationService.authenticate() - Credentials = ' + credentials)
      HTTP.post('security/login', {}, {
        headers: {
          Authorization: 'Basic ' + credentials
        }
      })
      .then(response => {
        // console.log('AuthenticationService.authenticate() - authenticated successfully')
        this.user = response.data
        // store to local storage
        // console.log('AuthenticationService.authenticate() - storing user to sessionStorage')
        sessionStorage.setItem('user', JSON.stringify(this.user))
        // console.log('AuthenticationService.authenticate() - setting http authorization headers')
        HTTP.defaults.headers.Authorization = 'Basic ' + credentials
        sessionStorage.setItem('credentials', JSON.stringify(credentials))
        resolve(this.user)
      })
      .catch(e => {
        console.log('AuthenticationService.error=>' + e)
        reject(e)
      })
    })
  }

  /**
   * This method will logout the logged-in user
   * This following actions is performed
   * 1.) Set the user member to null to notify VueJS that the user is logged out
   * 2.) Remove the user from the local storage
   * 3.) Remove the credentials from the local storage
   */
  logout () {
    // console.log('AuthenticationService.logout()')
    this.user = null
    // console.log('AuthenticationService.logout() - removing user from sessionStorage')
    sessionStorage.removeItem('user', null)
    // console.log('AuthenticationService.authenticate() - removing http authorization headers')
    HTTP.defaults.headers.Authorization = null
    sessionStorage.removeItem('credentials')
  }

  updateCredential (password) {
    var credentials = btoa(this.user.username + ':' + password)
    HTTP.defaults.headers.Authorization = 'Basic ' + credentials
    sessionStorage.setItem('credentials', JSON.stringify(credentials))
  }
  /**
   * Check if the logged-in user has the given authority. If user is not logged-in it returns false
   */
  hasAuthority (authority) {
    if (this.user == null) {
      return false
    }
    for (var i = 0; i < this.user.authorities.length; i++) {
      var thisAuthority = this.user.authorities[i]
      if (thisAuthority === authority) {
        return true
      }
    }
    return false
  }
}
export const authenticationService = new AuthenticationService()



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js